import errorLink from "@/vue-apollo/links/error";
import {
  createHttpLink,
  InMemoryCache,
  from,
} from "@apollo/client/core";
import { queries as upcomingCollectionsQueries } from "@/graphql/upcoming-collection/cache-redirects";


const cmsHttpLink = new createHttpLink({
  uri: process.env.VUE_APP_GRAPHQL_HTTP_CMS || "https://cms.compass.art/graphql",
  useGETForQueries: false,
})

const cmsClientOptions = {
  link: from([ errorLink, cmsHttpLink ]),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          ...upcomingCollectionsQueries,
        }
      }
    }
  }),
};

export default cmsClientOptions;